import type { App } from 'vue'

function checkVisible(el: HTMLElement) {
  var rect = el.getBoundingClientRect()
  var viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight)
  return !(rect.bottom < 0 || rect.top - viewHeight >= 0)
}

export const detectAndShow = (app: App) => {
  app.directive('detect-element', (el: HTMLElement, biding) => {
    if (checkVisible(el)) {
      biding.value()
    }

    window.addEventListener('scroll', () => {
      if (checkVisible(el)) {
        biding.value()
      }
    })
  })
}
